<section class="pit-card coverage">
  <div class="pit-card__head">
    <div>
      <h3 class="pit-title">Capacidade livre de garantia por sócio</h3>
      <p class="pit-caption">
        Quanto dos bens de cada sócio serve de garantia pela política de garantias, separando o que
        tem restrição
      </p>
    </div>
  </div>

  <div class="coverage__partners">
    @for (bar of bars(); track bar.personId) {
      <div>
        <div class="coverage__partner-line">
          <span class="pit-strong">{{ bar.displayName }}</span>
          <span class="pit-text">{{ bar.label }}</span>
        </div>
        <div class="coverage__bar">
          <span class="coverage__seg--free" [style.width.%]="bar.unrestrictedWidth"></span>
          <span class="coverage__seg--restricted" [style.width.%]="bar.restrictedWidth"></span>
        </div>
      </div>
    }
  </div>
  <div class="coverage__legend pit-caption">
    <span><i class="coverage__swatch coverage__seg--free"></i>Sem restrição</span>
    <span
      ><i class="coverage__swatch coverage__seg--restricted"></i>Com restrição (anuência, alienação,
      quotistas)</span
    >
    <span
      >Barra cheia = capacidade livre somada ({{ money(consolidated().freeCollateralTotal) }})</span
    >
  </div>
</section>
